import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { StarMark } from "@/components/Logo";

export default function SsoCallback() {
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    const returnTo = params.get("return_to");
    if (!token) {
      navigate("/login?sso_error=missing", { replace: true });
      return;
    }
    // Only honour cross-origin return_to to ekselens-family hosts —
    // mirror of the backend allow-list. Anything else falls back to /dashboard.
    const safeReturn = (() => {
      if (!returnTo) return null;
      try {
        const u = new URL(returnTo);
        const host = u.hostname.toLowerCase();
        if (host === "ekselens.com" || host.endsWith(".ekselens.com") || host === window.location.hostname) {
          return returnTo;
        }
      } catch {/* ignore */}
      return null;
    })();
    loginWithToken(token)
      .then(() => {
        if (safeReturn) {
          window.location.replace(safeReturn);
        } else {
          navigate("/dashboard", { replace: true });
        }
      })
      .catch(() => {
        setError("We couldn't complete SSO sign-in. Redirecting you back…");
        setTimeout(() => navigate("/login?sso_error=session", { replace: true }), 2200);
      });
  }, [params, navigate, loginWithToken]);

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-4 bg-ek-canvas px-6 text-center"
      data-testid="sso-callback"
    >
      <StarMark size={36} className="animate-pulse text-ek-purple" />
      {error ? (
        <p className="text-sm text-red-600" data-testid="sso-callback-error">{error}</p>
      ) : (
        <p className="text-sm text-ek-ink/60">Signing you in via SSO…</p>
      )}
    </div>
  );
}
